import * as React from 'react';

function SvgPicks(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="22" viewBox="0 0 15 22" width="15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.2 12.3333H1L11.4 1L8.8 9.66667H14L3.6 21L6.2 12.3333Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default SvgPicks;
